import { MutationHookOptions, useMutation } from '@apollo/client'
import { ADD_TO_CART, CANCEL_CART } from './mutations'

export type MutateAddToCartProps = {
  tevoTicketGroupId?: number
  packageId?: string
  quantity: number
}

type useCancelCartMutationProps = {
  cartId: string
}

type MutateAddToCartResponse = {
  createCart: {
    cart?: {
      id: string
    }
    errorMessage?: string
  }
}

const useAddToCartMutation = (options: MutationHookOptions = {}) => {
  const [addToCart, { loading, error, data }] = useMutation<MutateAddToCartResponse>(
    ADD_TO_CART,
    options
  )

  const mutate = (variables: MutateAddToCartProps) => addToCart({ variables })

  return {
    data,
    error,
    mutate,
    loading,
  }
}

const useCancelCartMutation = (options: MutationHookOptions = {}) => {
  const [updateCart, { loading, error }] = useMutation(CANCEL_CART, options)

  const mutate = (variables: useCancelCartMutationProps) => updateCart({ variables })

  return {
    error,
    mutate,
    loading,
  }
}

export { useAddToCartMutation, useCancelCartMutation }
